import { call } from 'redux-saga/effects'
import sweetalert from 'sweetalert2'

export default function * showSweetalert (action) {
  const { onConfirm, onCancel, ...sweetalertArgs } = action.payload

  try {
    yield call(sweetalert, sweetalertArgs)

    if (onConfirm) yield call(onConfirm)
  } catch (e) {
    if (onCancel) yield call(onCancel)
  }
}

